import { render, staticRenderFns } from "./twoColGoods.vue?vue&type=template&id=2d40963d&scoped=true&"
import script from "./twoColGoods.vue?vue&type=script&lang=js&"
export * from "./twoColGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d40963d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d40963d')) {
      api.createRecord('2d40963d', component.options)
    } else {
      api.reload('2d40963d', component.options)
    }
    module.hot.accept("./twoColGoods.vue?vue&type=template&id=2d40963d&scoped=true&", function () {
      api.rerender('2d40963d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xcxPos/home/child/twoColGoods.vue"
export default component.exports